<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperEvaluationDiscussion',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'EvaluationDiscussionModule',
    };
  },
};
</script>
